export const UNIT_NUMBERING_RULES = {
  all: { step: 1, remainder: null },
  even: { step: 2, remainder: 0 },
  odd: { step: 2, remainder: 1 },
} as const;

export type TUnitNumbering = keyof typeof UNIT_NUMBERING_RULES;

export const DEFAULT_UNIT_NUMBERING: TUnitNumbering = 'all';

export const UNIT_NUMBERING_OPTIONS: { label: string; value: TUnitNumbering }[] = [
  { label: 'All numbers', value: 'all' },
  { label: 'Odd numbers', value: 'odd' },
  { label: 'Even numbers', value: 'even' },
];

export const matchesUnitNumbering = (from: number, numbering?: TUnitNumbering) => {
  const remainder = numbering && UNIT_NUMBERING_RULES[numbering].remainder;

  return remainder == null || Math.abs(from % 2) === remainder;
};
